import React from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import Colours from '@shared/ui/atoms/Colours';
import { selectSignage } from '../data/signage.duck';
import { SignagePairingScreen } from '../components/SignagePairingScreen';
import { SignageTopBar } from '../components/SignageTopBar';
import { SignageView } from '../components/SignageView';

export function SignagePage() {
  const signage = useSelector(selectSignage);

  return (
    <Page>
      <SignageTopBar />
      {signage.paired ? (
        <SignageView />
      ) : (
        <PairingWrapper>
          <SignagePairingScreen />
        </PairingWrapper>
      )}
    </Page>
  );
}

const Page = styled.div`
  height: 100vh;
  background: ${Colours.veryLightGrey};
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const PairingWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
`;
